import { render, staticRenderFns } from "./aiAsk.vue?vue&type=template&id=5ae2d302&scoped=true"
import script from "./aiAsk.vue?vue&type=script&lang=ts"
export * from "./aiAsk.vue?vue&type=script&lang=ts"
import style0 from "./aiAsk.vue?vue&type=style&index=0&id=5ae2d302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2d302",
  null
  
)

export default component.exports